import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0;
`;

const CardBody = ({ children, ...params }) => {
  return <Wrapper {...params}>{children}</Wrapper>;
};

export default CardBody;
